import { type TFunction } from "i18next";
import { notifications } from "@mantine/notifications";

export const failureDuringStaking = (
  t: TFunction,
): void => {
  notifications.show({
    message: t('during_staking'),
    title: t('something_went_wrong'),
    color: 'red',
  });
};
